"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_query_1 = require("react-query");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var config_action_1 = require("../../../actions/config_action");
var button_component_1 = require("../../../common/buttons/button_component");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var pop_up_1 = require("../../../common/modal/pop-up");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var search_component_1 = require("../../../common/search/search_component");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../constants/appConstants");
var route_path_1 = require("../../../constants/route_path");
var table_data_1 = require("../../../constants/table_data");
var menu_constants_1 = require("../../../menuList/menu_constants");
var array_helpers_1 = require("../../../utils/array_helpers");
var reports_helper_1 = require("../reports/reports_helper");
var state_city_filter_1 = require("../sample_traking/state_city_filter");
var CC_api_calls_1 = require("./CC_api_calls");
var CC_listing = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var nav = (0, react_router_1.useNavigate)();
    var _a = React.useState(), dataList = _a[0], setDataList = _a[1];
    var labList = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.labList; });
    var CenterType = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.center_type; });
    var _b = React.useState(0), totalCount = _b[0], setTotalCount = _b[1];
    var _c = React.useState([]), filterStateCity = _c[0], setFilterStateCity = _c[1];
    var _d = React.useState(''), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = React.useState(null), selectlab = _e[0], setSelectedLab = _e[1];
    var _f = React.useState(null), centretype = _f[0], setcentretype = _f[1];
    var _g = React.useState(''), errorMessage = _g[0], setErrorMessage = _g[1];
    var _h = React.useState(0), totalPageCount = _h[0], setTotalPageCount = _h[1];
    var _j = React.useState(1), pageCount = _j[0], setpageCount = _j[1];
    var _k = React.useState(appConstants_1.defaultPageLimit), PageLimit = _k[0], setPageLimit = _k[1];
    var navigateToaddSlot = function () {
        nav("/".concat(route_path_1.default.PATHS.addCCSlot));
    };
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.CC_Roster_Management);
    var _l = React.useState(false), open = _l[0], setOpen = _l[1];
    var navigate = (0, react_router_1.useNavigate)();
    var stateCityHandler = function (event) {
        if (event.length >= 0) {
            setFilterStateCity(event);
        }
    };
    var searchingHandler = function (e) {
        setSearchTerm(e.target.value);
    };
    var LabHandler = function (Lab) {
        setSelectedLab(Lab);
    };
    var CentretypeHandler = function (centretype) {
        setcentretype(centretype);
    };
    var refetch = (0, react_query_1.useQuery)(['sample-tracking-list', pageCount], function () {
        var currentPage = pageCount < 0 ? 0 : pageCount;
        var payload = {};
        if (filterStateCity.length > 0) {
            var states_1 = [];
            var cities_1 = [];
            filterStateCity.map(function (selectedCityObj) {
                if (!states_1.includes(selectedCityObj.state_name)) {
                    states_1.push(selectedCityObj.state_name);
                }
                cities_1.push(selectedCityObj.short_code);
            });
            payload['state'] = states_1;
            payload['city'] = cities_1;
        }
        if (searchTerm.trim().length >= 3) {
            payload.search_string = searchTerm.toLocaleLowerCase().trim();
        }
        if (selectlab !== null) {
            payload.lab_code = selectlab.value;
        }
        if (centretype !== null) {
            payload.center_type = centretype.label;
        }
        payload['page'] = currentPage;
        payload['size'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        (0, CC_api_calls_1.fetchCCTimeSlotList)(payload)
            .then(function (response) {
            var pageSize = PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setErrorMessage('');
            setTotalPageCount(count);
            setDataList(response.result);
            setTotalCount(response.count);
        })
            .catch(function (err) {
            setErrorMessage(err.message);
            setDataList([]);
        });
    }).refetch;
    var autoGenerateReportHandler = function () {
        var currentPage = pageCount < 0 ? 0 : pageCount;
        var payload = {};
        if (filterStateCity.length > 0) {
            var states_2 = [];
            var cities_2 = [];
            filterStateCity.map(function (selectedCityObj) {
                if (!states_2.includes(selectedCityObj.state_name)) {
                    states_2.push(selectedCityObj.state_name);
                }
                cities_2.push(selectedCityObj.short_code);
            });
            payload['state'] = states_2;
            payload['city'] = cities_2;
        }
        if (searchTerm.trim().length >= 3) {
            payload.search_string = searchTerm.toLocaleLowerCase().trim();
        }
        if (selectlab !== null) {
            payload.lab_code = selectlab.value;
        }
        if (centretype !== null) {
            payload.center_type = centretype.label;
        }
        payload['page'] = currentPage;
        payload['size'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        (0, reports_helper_1.centerMasterExcel)(payload)
            .then(function (res) {
            if (res.data.statusCode === 200) {
                if (res.data.message != 'Success') {
                    react_hot_toast_1.default.error(res.data.message);
                }
                else {
                    setOpen(true);
                }
            }
            else {
                react_hot_toast_1.default.error(res.data.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.data.errors);
        });
    };
    var navigateToMyReports = function () {
        dispatch((0, config_action_1.featchCurrentActiveMenu)({
            mainModule: menu_constants_1.FEATURE_CONSTANTS.reports,
            subModule: menu_constants_1.FEATURE_CONSTANTS.sub_my_reports,
            subChaildModule: '',
        }));
        navigate("/".concat(route_path_1.default.PATHS.MYREPORTS));
    };
    var FilterHandler = function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    };
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var onRowClickedHandler = function (event) {
        if (features[menu_constants_1.FEATURE_CONSTANTS.updateCCTimeWindow]) {
            nav("".concat(route_path_1.default.PATHS.addCCSlot, "/").concat(event.data.warehouse_code));
        }
    };
    var handlePageLimitChange = function (val) {
        setPageLimit(val);
    };
    return (React.createElement("div", { className: "fe-wrapper" },
        React.createElement("div", { className: "tool-bar-wrapper" },
            React.createElement("div", { className: "page-heaidng" },
                React.createElement("h2", null, "Client Time Slot Management")),
            React.createElement("div", { className: "page-control-wrapper" },
                React.createElement(button_component_1.default, { type: "button", buttonName: appConstants_1.reportDownload, color: "yellow-outline", isError: (dataList === null || dataList === void 0 ? void 0 : dataList.length) > 0 ? false : true, endIcon: "icon-import download-icon", onClickHandler: autoGenerateReportHandler }),
                React.createElement(button_component_1.default, { buttonName: "ADD TIME WINDOW", color: "yellow", onClickHandler: navigateToaddSlot }))),
        React.createElement("div", { className: "filter-menu-wrapper" },
            React.createElement("div", { className: "search-filter" },
                React.createElement(search_component_1.default, { placeholder: "Search Client Name", searchValue: searchTerm, searchHandler: searchingHandler })),
            React.createElement("div", { className: "filter-options" },
                React.createElement("div", { className: "filter-options city-state-wrapper" },
                    React.createElement(drop_down_component_1.default, { disableClearable: true, name: "centerlist", value: centretype || null, dropDownList: CenterType, placeholder: "Select center", onChange: CentretypeHandler })),
                React.createElement(state_city_filter_1.default, { name: "CC", onChangeHandler: stateCityHandler }),
                React.createElement(drop_down_component_1.default, { disableClearable: true, name: "cclist", value: selectlab || null, dropDownList: (0, array_helpers_1.convertLabcodeResponse)(labList), placeholder: "Lab code", onChange: LabHandler }),
                React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.paginationDropdown, onChange: handlePageLimitChange, value: PageLimit }),
                React.createElement(button_component_1.default, { buttonName: "FILTERS", color: "yellow-outline", onClickHandler: FilterHandler }))),
        React.createElement("div", { className: "fe-wrapper pay  -fe-wrapper" },
            React.createElement("div", { className: "scrollable-content ".concat(features[menu_constants_1.FEATURE_CONSTANTS.updateCCTimeWindow]
                    ? 'clickable-row'
                    : 'unclickablerow') },
                React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.CC_TIME_SLOT, rows: dataList, errorMessage: errorMessage, pagination: false, onRowClicked: onRowClickedHandler, className: 'client-roster-table' }),
                React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: dataList === null || dataList === void 0 ? void 0 : dataList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value })),
            React.createElement(pop_up_1.default, { open: open },
                React.createElement("div", { className: "modal-header" },
                    React.createElement("h2", { className: "heading" }, "Request Submitted"),
                    React.createElement("h2", { className: "sub-heading" }, "Please view your report in My Reports section")),
                React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                    React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setOpen(false); } }),
                    React.createElement(button_component_1.default, { buttonName: "My Reports", color: "yellow", onClickHandler: navigateToMyReports, isError: false }))))));
};
exports.default = CC_listing;
